import { useMemo } from "react";
import { useAppSelector } from "@/core/store";
import { useGuestImageUrls } from "@/core/menu/images";
import { selectCartItems, selectCurrentOrder } from "@/core/orders/selectors";
import { selectPointId } from "@/core/app/selectors";

/**
 * Карта id → url для картинок позиций корзины.
 *
 * Снимок заказа несёт imageId, а не готовый URL: адреса читаются отдельным
 * запросом, тем же, что и обложки меню (чанкование по 100, useQueries +
 * combine).
 *
 * Точка берётся ИЗ ЗАКАЗА, а не из app.pointId: при EDIT_ORDER они могут
 * отличаться, а идентификаторы чужого бренда сервер молча отсеивает —
 * картинки исчезли бы без единой ошибки. Пока заказа нет, корзина локальна
 * и точка у неё одна — из приложения.
 */
export function useCartImageUrls(): Record<string, string> {
  const currentOrder = useAppSelector(selectCurrentOrder);
  const appPointId = useAppSelector(selectPointId);
  const cartItems = useAppSelector(selectCartItems);

  // Точка заказа — только когда заказ существует: clearOrder при смене точки
  // сохраняет прежний pointId, и локально набранная корзина просила бы
  // картинки у старой точки (сервер молча отсеял бы чужие id).
  const pointId = currentOrder.id
    ? currentOrder.pointId || appPointId
    : appPointId;

  const imageIds = useMemo(
    () => cartItems.map((item) => item.productSnapshot.imageId),
    [cartItems]
  );

  return useGuestImageUrls(pointId, imageIds);
}
